import React, { useState, useEffect, useContext } from "react";
import ModelContext from "../ModelContext";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./imagegallery-swiper-styles.css";

export const ImageAnimationDouble = (props) => {
    const [animations, setAnimations] = useState(["A01", "A02"]);
    const [swiperImageRef, setSwiperImageRef] = useState(null);

    const modelCtx = useContext(ModelContext);

    const handleChangeSlide = (swiper) => {
        let index = swiper.activeIndex;
        if (index === 0) {
            setAnimations(["A02", "A01"]);
        }

        if (index === 1) {
            setAnimations(["B02", "B01"]);
        }

        swiperImageRef.slideTo(0);

    };

    return (
        <>
            <div className="row align-items-center">
                <div className="col-lg-6 col-12">
                    <Swiper
                        onSwiper={setSwiperImageRef}
                        modules={[EffectFade, Navigation, Pagination, Autoplay]}
                        spaceBetween={50}
                        effect={"fade"}
                        speed={3000}
                        loop={true}
                        autoplay={{
                            delay: 4500,
                            disableOnInteraction: false,
                        }}
                        fadeEffect={{
                            crossFade: true,
                        }}
                    >

                        {animations.map((animationIndex, i) => (
                            <SwiperSlide key={i}>
                                <div className="box text-right">
                                    <img src={`images/N50/animation-double-${animationIndex}.jpg`} alt={`Exterior ${animationIndex}`} className="images-animation-double" />
                                </div>
                            </SwiperSlide>
                        ))}

                    </Swiper>
                </div>
                <div className="col-lg-6 col-12 descriptions">

                    <Swiper
                        modules={[Navigation, Pagination]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation={{
                            nextEl: '.swiper-animation-button-next',
                            prevEl: '.swiper-animation-button-prev',
                        }}
                        onSlideChange={(swiper) => handleChangeSlide(swiper)}
                    >
                        <SwiperSlide>
                            <div className="box text-center">
                                <div className="text-left tile text-animation-double">
                                    <p className="text4 color-blue wow fadeInUp text-spacing-animation" data-wow-delay="0.1s">
                                        In the superb, sophisticated large saloon on the <strong>main deck</strong>, sunlight is always a welcome guest. <br /><br />
                                        The <strong>tall, sweeping windows</strong> allow the gaze to roam, for an endless sensation of <strong>intimacy with the sea</strong>.
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="box text-center">
                                <div className="text-left tile text-animation-double">
                                    <p className="text4 color-blue wow fadeInUp text-spacing-animation" data-wow-delay="0.1s">
                                        The <strong>heart</strong> of the Custom Line 50 is the <strong>upper-deck</strong> owner's apartment. <br /><br />
                                        Its innovative positioning offers stunning <strong>180-degree views</strong> through full-height windows that bathe the whole room in natural light.
                                    </p>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                    <div className="col-12 text-center custom-navigation-position">
                        <span className="swiper-animation-button-prev"><NavigateBeforeIcon style={{ color: '#8E7A6A' }} /></span>
                        <span className="swiper-animation-button-next"><NavigateNextIcon style={{ color: '#8E7A6A' }} /></span>
                    </div>
                </div>
            </div>

        </>
    );
};

export default ImageAnimationDouble;
